import { easyEstimatorApi } from '../easyEstimatorService';

import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { ApiUrl } from '~/core/enums';
import { CutoutLaborModel } from '~/core/models';

const cutoutLaborService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCutoutLabor: builder.query<
      CutoutLaborModel[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.CUTOUT_LABOR,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchCutoutLaborQuery } = cutoutLaborService;
